import '.ey{font-size:1.125rem;}.ssr-plugin'
import '.d3{line-height:1.75rem;}.ssr-plugin'
import '.et{text-decoration:none;}.ssr-plugin'
import '.fd{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="ey d3"
    >
      {translations.privacySubtitle}{' '}
      <a className="et fd"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="et fd"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
